import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function AffiliateRedirect() {
  const { handle } = useParams();

  useEffect(() => {
    let done = false;
    api.get(`/affiliate/${encodeURIComponent(handle)}`)
      .then(({ data }) => {
        const code = data && data.valid && data.code ? `?code=${encodeURIComponent(data.code)}` : "";
        if (!done) window.location.replace(`/${code}#prodotto`);
      })
      .catch(() => { if (!done) window.location.replace("/#prodotto"); });
    return () => { done = true; };
  }, [handle]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="affiliate-redirect">
      <Loader2 className="animate-spin text-white" />
    </div>
  );
}
